<template>
  <div>
      <full-page  ref="fullpageDownload" :options="options" id="fullpage">

        <div id="section000"  class="section">
          <h2>LOADING...</h2>

        </div>



        <div id="section121" class="section">
<div class="prodWrap">
          <b-container class="h-100">
            <b-row class="h-100 align-items-center justify-content-center">
              <b-col>

                  <b-row>
                    <b-col><h1>Downloadable Press Materials</h1></b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-card-group deck class="mb-3">
                        
                        <b-card class="text-center">
                            <p class="card-title">HIGH RESOLUTION ASSETS</p>
                            <p class="card-links"><a href="https://mediaroom.starz.com/" target="_blank">Visit Starz Media Room to Download High Resolution Images and Videos</a></p>
                            
                        </b-card>

                        <b-card class="text-center">
                            <p class="card-title">PRESS PDF ASSETS</p>
                            <p class="card-links"><a href="/americangodsS2/static/pdf/AGS2_BIOS_Cast.pdf" target="_blank">Cast Biographies</a></p>
                            <p class="card-links"><a href="/americangodsS2/static/pdf/AGS2_Key_Character_Descriptions.pdf" target="_blank">Characters</a></p>
                            <p class="card-links"><a href="/americangodsS2/static/pdf/AGS2_Additional_Characters_Descriptions.pdf" target="_blank">Additional Characters</a></p>
                            <p class="card-links"><a href="/americangodsS2/static/pdf/AGS2_BIOS_Additional_Cast.pdf" target="_blank">Additional Cast Biographies</a></p>
                            <p class="card-links"><a href="/americangodsS2/static/pdf/AGS2_BIOS_Filmmaker.pdf" target="_blank">Filmakers Biographies</a></p>
                            <p class="card-links"><a href="/americangodsS2/static/pdf/AGS2_Credits_Cast.pdf" target="_blank">Cast Credits</a></p>
                            <p class="card-links"><a href="/americangodsS2/static/pdf/AGS2_CREDITS_Production.pdf" target="_blank">Production Credits</a></p>
                            <p class="card-links"><a href="/americangodsS2/static/pdf/AGS2_Episodic_Synopsis_201_203_Press_Kit.pdf" target="_blank">Episodic Synopsis</a></p>
                            <p class="card-links"><a href="/americangodsS2/static/pdf/AGS2_ProdNotes_FINAL.pdf" target="_blank">Production Notes</a></p>
      

                        </b-card>

                    </b-card-group>

                    </b-col>
                  </b-row>
              </b-col>
              </b-row>
          </b-container>
                    <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />

</div>
        </div>


      </full-page>
  </div>
</template>

<script>

export default {
  name: 'Downloads',
  metaInfo: {
    title: 'Downloads' // set a title
  },
  data () {
    return {
      options: {
        licenseKey: '08F6AFDB-F75D4F5A-AE124C87-3D28719F',
        menu: '#menu',
        anchors: ['loading', 'downloads'],
        slidesNavigation: true,
        controlArrows: true,
        scrollOverflow: true,
        lazyLoading: false,
        onLeave: this.onLeave,
        afterLoad: this.afterLoad
      }
    }
  },
  methods: {
    afterLoad (origin, destination, direction) {
      if (destination.index === 0) {
        this.$refs.fullpageDownload.api.moveSectionDown()
      }
    },
    onLeave (origin, destination, direction) {
      if (destination.index === 0) {
        document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
        document.getElementById('stzHeaderTitleArt').classList.remove('logo')
      }
      if (origin.index === 1 && destination === 'up') {
        document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
        document.getElementById('stzHeaderTitleArt').classList.remove('logo')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../styles/Downloads.scss";
</style>



// WEBPACK FOOTER //
// src/components/Downloads.vue